import { useEffect } from "react";
import { forceLogin } from "./login.core";
import { setShopIdToCookies, setShopIdToSession } from "./shop.core";
import Cookies from "js-cookie";

async function performInit(): Promise<void> {
  if (window.location.pathname.startsWith("/user/verify")) return;
  if (window.location.pathname.startsWith("/user/resetPwd")) return;

  await forceLogin();
}

export let initPromise: Promise<void>;

export default function init() {
  initPromise = performInit();
}

// whenever a tab is visited/clicked, get the shopId from the sessionStorage
// on that tab and then sync that with the Cookies storage. see docs pos.md Shop Selection
export function useSyncSessionAndCookies() {
  useEffect(() => {
    function handeShopId() {
      const tabShopId = sessionStorage.getItem("shopId");
      const cookiesShopId = Cookies.get("shopId");

      if (tabShopId !== null) {
        setShopIdToCookies(tabShopId);
      } else if (cookiesShopId) {
        setShopIdToSession(cookiesShopId);
      }
    }

    window.addEventListener("visibilitychange", handeShopId);
    return () => {
      window.removeEventListener("visibilitychange", handeShopId);
    };

    // eslint-disable-next-line
  }, []);
}
